import * as React from 'react'
import { Typography } from '@mui/material'
import {formatPercentage, formatPriceSymbol} from "@ui-seeker/utils";


export default function priceColumn(value, label) {
    const config = { displayZero: true}
    return {
        name: value, label: label,
        options: {
            filter: false,
			setCellHeaderProps: () => ({ sx: { whiteSpace: 'pre-wrap' } }),
            customBodyRowRenderLite: (value, { currency }) => <Typography>
                {formatPriceSymbol(value, currency, config)}
            </Typography>
        }
    }
}